module.exports = __webpack_public_path__ + "img/429.2125ac06.jpg";